import { createClient } from '@supabase/supabase-js';

// TODO: User needs to provide their Project URL
const SUPABASE_URL = process.env.VITE_SUPABASE_URL || 'https://cuqitetvtjnlafgdwtyx.supabase.co';
const SUPABASE_ANON_KEY = process.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_K4cGP1ZoYT10JoNrXFOEqQ_H-C7Q9dt';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
